import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import type {
  SearchHubSpotContactsInput,
  SearchHubSpotContactsResponse,
  GetHubSpotContactInput,
  GetHubSpotContactResponse,
} from "@event-planner/shared";

/**
 * Callable wrappers for the HubSpot CRM reads (ADR-169 Stage 2,
 * review-first per ADR-172). Both are pure reads — the token never
 * leaves the server, and linking commits client-side through the
 * person form's normal save paths. The URL builder and pull
 * computation live in `utils/hubspot.ts`.
 */

const searchHubSpotContactsCallable = httpsCallable<
  SearchHubSpotContactsInput,
  SearchHubSpotContactsResponse
>(functions, "searchHubSpotContacts");

const getHubSpotContactCallable = httpsCallable<
  GetHubSpotContactInput,
  GetHubSpotContactResponse
>(functions, "getHubSpotContact");

export async function searchHubSpotContacts(
  input: SearchHubSpotContactsInput,
): Promise<SearchHubSpotContactsResponse> {
  const result = await searchHubSpotContactsCallable(input);
  return result.data;
}

export async function getHubSpotContact(
  input: GetHubSpotContactInput,
): Promise<GetHubSpotContactResponse> {
  const result = await getHubSpotContactCallable(input);
  return result.data;
}
